import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {CareproviderAddress} from '../../../types/CareproviderAddress';
import {CareproviderUnitImages} from '../../../types/CareproviderUnitImages';
import {ToolsService} from '../../../services/tools.service';

@Component({
  selector: 'app-cpru-map',
  templateUrl: './cpru-map.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruMapComponent {
  public id = input<number>(null);
  public urlPath = input<string>(null);
  public address = input<CareproviderAddress>(null);
  public caregiverUnitImages = input<CareproviderUnitImages>(null);
  public name = input<string>(null);
  private tools = inject(ToolsService);
  public hasMap = computed<boolean>(() => !this.tools.isNil(this.address()) && this.address().latitude !== 0);
}
